import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import { fetchIntegrations } from '../../skeleton/src/workspaces/api';
import { queryClient } from '../core/queryClient';

type FetchIntegrationsResult = Awaited<ReturnType<typeof fetchIntegrations>>;
type IntegrationsQueryOptions = Omit<QueryObserverOptions<FetchIntegrationsResult>, 'queryKey' | 'queryFn'>;

export const integrationsQueryKey = () => ['integrations'];

const integrationsQueryOptions = () => ({
  queryKey: integrationsQueryKey(),
  queryFn: () => fetchIntegrations(),
  gcTime: Infinity,
  refetchOnReconnect: false,
  refetchOnWindowFocus: false,
  retry: false as const,
  staleTime: Infinity
});

export const ensureIntegrationsData = (): Promise<FetchIntegrationsResult> =>
  queryClient.ensureQueryData(integrationsQueryOptions());

export const integrationsQuery = (options?: IntegrationsQueryOptions): QueryObserver<FetchIntegrationsResult> =>
  new QueryObserver<FetchIntegrationsResult>(queryClient, {
    ...integrationsQueryOptions(),
    ...options
  });
